import {
  Card,
  Grid,
  Stack,
  TextField,
  FormControlLabel,
  Button,
  Checkbox,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import { useAppDispatch, useAppSelector } from '../../../store';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LocationManagement as ILocationManagement } from '../../../store/locationManagement/api/interface';
import { useFormik } from 'formik';
import {
  createLocationManagement,
  getLocationManagement,
  patchLocationManagement,
} from '../../../store/locationManagement/api';
import { setStatus } from '../../../store/locationManagement/locationManagementSlice';
import { useEffect, useRef, useState } from 'react';
import { decryptString } from '../../../utils/url';
import Loader from '../../../components/Loader';
import { omit } from 'lodash';
// import {
//   setStatus as selectLocationManagementSetStatus,
//   reset as resetSelectLocationManagementReset,
// } from '../../../store/locationManagement/locationManagementSlice';
import locationManagementSchema from '../../../validation/locationManagementSchema';
import { NumericFormatCustom } from '../../../components/NumericCustomFormatter';
// import { LatLngExpression } from 'leaflet';
// import {
//   MapContainer,
//   Marker,
//   Popup,
//   TileLayer,
//   useMapEvents,
// } from 'react-leaflet';
// import 'leaflet/dist/leaflet.css';
// import { customIcon } from '../../../utils/icon';
import {
  GoogleMap,
  Marker,
  useJsApiLoader,
  Autocomplete,
} from '@react-google-maps/api';

const LocationManagementForm = () => {
  const dispatch = useAppDispatch();
  const navigation = useNavigate();
  const params: any = useParams();
  const location = useLocation();
  const state = location.state as ILocationManagement;

  const isAddMode = !params?.id;
  const { isLoading } = useAppSelector((state) => state.locationManagement);

  // const [mapCoordinates, setMapCoordinates] = useState<LatLngExpression>([
  //   25.3548, 51.1839,
  // ]);
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const [mapCoordinates, setMapCoordinates] =
    useState<google.maps.LatLngLiteral>({
      lat: 25.3548,
      lng: 51.1839,
    });

  const {
    handleSubmit,
    values,
    setValues,
    handleChange,
    setFieldValue,
    resetForm,
    isSubmitting,
    errors,
    touched,
  } = useFormik({
    initialValues: {
      id: '',
      labelEn: '',
      labelAr: '',
      code: '',
      position: '',
      latitude: 0,
      longitude: 0,
      activeState: true,
    },
    validationSchema: locationManagementSchema,
    onSubmit: async (values) => {
      try {
        if (isAddMode) {
          const reqBody = omit(values, ['id']);
          await dispatch(createLocationManagement(reqBody)).unwrap();
        }
        if (!isAddMode) {
          const reqBody: any = values;
          delete reqBody.createdAt;
          delete reqBody.createdBy;
          delete reqBody.updatedAt;
          delete reqBody.updatedBy;
          delete reqBody.location;
          await dispatch(patchLocationManagement(reqBody)).unwrap();
        }
        resetForm();
        dispatch(setStatus({ status: 'idle' }));
        navigation('/location-management');
      } catch (error: any) {}
    },
  });

  useEffect(() => {
    const fetchById = async () => {
      if (isAddMode) return;

      if (state) {
        if (state?.latitude !== 0 && state?.longitude !== 0) {
          setMapCoordinates({ lat: state.latitude, lng: state.longitude });
          // setMapCoordinates([state.latitude, state.longitude]);
        }
        setValues(state);
      } else {
        try {
          const decodeParam = decryptString(params.id);
          const record = await dispatch(
            getLocationManagement({ id: decodeParam })
          ).unwrap();
          if (record?.latitude !== 0 && record?.longitude !== 0) {
            setMapCoordinates({ lat: record.latitude, lng: record.longitude });
            // setMapCoordinates([record.latitude, record.longitude]);
          }
          setValues(record);
        } catch (error: any) {
          navigation('/location-management');
        }
      }
    };
    fetchById();
  }, [dispatch, isAddMode, navigation, params?.id, setValues, state]);

  // const handleMapClick = (e: L.LatLng) => {
  //   setFieldValue('latitude', e.lat);
  //   setFieldValue('longitude', e.lng);
  // };

  const handleMapClick = (e: google.maps.MapMouseEvent) => {
    if (e.latLng) {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      setFieldValue('latitude', lat);
      setFieldValue('longitude', lng);
      setMapCoordinates({ lat, lng });
    }
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY ?? '',
    libraries: ['places'],
  });

  const handlePlaceSelected = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();
      if (place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setFieldValue('latitude', lat);
        setFieldValue('longitude', lng);
        setMapCoordinates({ lat, lng });
      }
    }
  };

  return (
    <Grid
      container
      spacing={3}
      mt={1.5}
    >
      <Grid
        item
        xs={12}
        md={12}
      >
        {isLoading ? (
          <Loader />
        ) : (
          <form onSubmit={handleSubmit}>
            <Card sx={{ p: 3 }}>
              <Box
                sx={{
                  display: 'grid',
                  columnGap: 2,
                  rowGap: 3,
                  gridTemplateColumns: {
                    xs: 'repeat(1, 1fr)',
                    sm: 'repeat(2, 1fr)',
                  },
                }}
              >
                <TextField
                  fullWidth
                  label={'Label English'}
                  name='labelEn'
                  id='labelEn'
                  onChange={handleChange}
                  value={values.labelEn}
                  error={Boolean(errors.labelEn && touched.labelEn)}
                  helperText={
                    Boolean(errors.labelEn && touched.labelEn) && errors.labelEn
                  }
                />
                <TextField
                  fullWidth
                  label={'Label Arabic'}
                  name='labelAr'
                  id='labelAr'
                  onChange={handleChange}
                  value={values.labelAr}
                  error={Boolean(errors.labelAr && touched.labelAr)}
                  helperText={
                    Boolean(errors.labelAr && touched.labelAr) && errors.labelAr
                  }
                />
                <TextField
                  fullWidth
                  label={'Code'}
                  name='code'
                  id='code'
                  onChange={handleChange}
                  value={values.code}
                  error={Boolean(errors.code && touched.code)}
                  helperText={
                    Boolean(errors.code && touched.code) && errors.code
                  }
                />

                <TextField
                  fullWidth
                  label={'Position'}
                  name='position'
                  id='position'
                  onChange={handleChange}
                  InputProps={{
                    inputComponent: NumericFormatCustom as any,
                  }}
                  value={values.position}
                  error={Boolean(errors.position && touched.position)}
                  helperText={
                    Boolean(errors.position && touched.position) &&
                    errors?.position
                  }
                />
              </Box>

              <Grid
                container
                spacing={2}
                py={2}
              >
                <Grid
                  item
                  xs={12}
                  sm={4}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        color='primary'
                        name='activeState'
                        onChange={(e) =>
                          setFieldValue('activeState', e.target.checked)
                        }
                        checked={values.activeState}
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 70 } }}
                      />
                    }
                    label={'Active Status'}
                  />
                </Grid>
              </Grid>

              <Box
                sx={{
                  mt: 3,
                }}
              >
                <Typography
                  sx={{
                    mb: 2,
                    fontSize: '18px',
                  }}
                >
                  Set Location:
                </Typography>
                {isLoaded && (
                  <>
                    <Autocomplete
                      onLoad={(autocomplete) =>
                        (autocompleteRef.current = autocomplete)
                      }
                      onPlaceChanged={handlePlaceSelected}
                    >
                      <TextField
                        fullWidth
                        label='Search Location'
                        variant='outlined'
                      />
                    </Autocomplete>
                    <GoogleMap
                      mapContainerStyle={{
                        height: '400px',
                        width: '100%',
                        marginTop: '20px',
                      }}
                      center={mapCoordinates}
                      zoom={8}
                      onClick={handleMapClick}
                    >
                      <Marker position={mapCoordinates} />
                    </GoogleMap>
                  </>
                )}
                {/* <MapContainer
                  center={mapCoordinates}
                  zoom={8}
                  style={{ height: '400px', width: '100%' }}
                  attributionControl={false}
                >
                  <MapClickHandler handleClick={handleMapClick} />
                  <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
                  {values.latitude != null && values.longitude != null && (
                    <Marker
                      position={[values.latitude, values.longitude]}
                      icon={customIcon}
                    >
                      <Popup>{values?.labelEn}</Popup>
                    </Marker>
                  )}
                </MapContainer> */}
              </Box>

              <Stack
                alignItems='center'
                sx={{ mt: 3 }}
                direction='row'
                justifyContent='flex-end'
                gap={1}
              >
                <Button
                  variant='outlined'
                  onClick={() => navigation('/location-management')}
                >
                  {'Cancel'}
                </Button>

                <LoadingButton
                  type='submit'
                  variant='contained'
                  loading={isSubmitting}
                >
                  {isAddMode
                    ? 'Add Location Management'
                    : 'Edit Location Management'}
                </LoadingButton>
              </Stack>
            </Card>
          </form>
        )}
      </Grid>
    </Grid>
  );
};

export default LocationManagementForm;
